import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GrantDiscordAccessInputqu7hxtlblgwv as GrantDiscordAccessInput } from '../GrantDiscordAccessInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInput_InputAdapterClass;
function GrantDiscordAccessInput_InputAdapter() {
  if (GrantDiscordAccessInput_InputAdapterClass === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      f6t(writer, customScalarAdapters, value) {
        writer.o4a('code');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.y6p_1);
        writer.o4a('partyId');
        get_partyIdAdapter().u3x(writer, customScalarAdapters, value.z6p_1);
        writer.o4a('guildId');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.a6q_1);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.f6t(writer, customScalarAdapters, value instanceof GrantDiscordAccessInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GrantDiscordAccessInput_InputAdapter', VOID, VOID, [Adapter()]);
    GrantDiscordAccessInput_InputAdapterClass = $;
  }
  return GrantDiscordAccessInput_InputAdapterClass;
}
var GrantDiscordAccessInput_InputAdapter_instance;
function GrantDiscordAccessInput_InputAdapter_getInstance() {
  return GrantDiscordAccessInput_InputAdapter_instance;
}
//region block: init
GrantDiscordAccessInput_InputAdapter_instance = new (GrantDiscordAccessInput_InputAdapter())();
//endregion
//region block: exports
export {
  GrantDiscordAccessInput_InputAdapter_instance as GrantDiscordAccessInput_InputAdapter_instance1gizlq5c0bi2d,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput_InputAdapter.mjs.map
